export default __webpack_public_path__ + "static/media/error_circle.7945549e.png";